<template>
    <div class="w_anli_detail">
        <div class="swiper_banner">
            <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
                <template v-for="(item,index) in dto.albums">
                    <van-swipe-item :key="index"><img class="swiper_img" :src="utils.HandleImg(item,false,1)"></van-swipe-item>
                </template>
            </van-swipe>
            <div class="photo_num">
                <img src="../../assets/images/icon_pic.png">
                <span>{{dto.albums.length}}张</span>
            </div>
        </div>

        <div class="top_area">
            <div class="pro_title">
                <span class="mater_title">{{dto.title}}</span>
            </div>
            <div class="pro_click">
                <img class="see_img" src="../../assets/images/cmf_1.png">
                <span class="num">{{dto.click}}</span>
            </div>
        </div>

        <div class="con_item">
            <div class="big_title">设计指导</div>
            <div class="con_item_zhidao">
                <ul>
                    <li class="item">
                        <div class="l_title">行业</div>
                        <div class="r_icon">
                            <span>{{dto.anlihangye?dto.anlihangye:'--'}}</span>
                        </div>
                    </li>
                    <li class="item">
                        <div class="l_title">设计师</div>
                        <div class="r_icon">
                            <span>{{dto.designer?dto.designer:'--'}}</span>
                        </div>
                    </li>
                    <li class="item">
                        <div class="l_title">品牌</div>
                        <div class="r_icon">
                            <span>{{dto.brand?dto.brand:'--'}}</span>
                        </div>
                    </li>
                    <li class="item">
                        <div class="l_title">设计公司</div>
                        <div class="r_icon">
                            <span>{{dto.designer_company?dto.designer_company:'--'}}</span>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <div id="one" class="con_item">
            <div class="big_title">案例描述</div>
            <div class="con_item_jieshao">
                <div class="jieshao_text" v-html="utils.HandleContentImg(dto.content)"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            id:this.$route.params.id,
            dto:'',
        }
    },
    created(){
        this.GetAnliDetail();
    },
    methods:{
        GetAnliDetail(){
            var url="http://api.xincailiao.com/Open/GetAnliDetail";
            // material_id:this.id
            this.$http.post(url,{id:this.id}).then((res)=>{
                if (res.data.status==1){
                    this.dto=res.data.ds;
                    this.dto.albums = this.dto.albums.split(',');
                    console.log(this.dto);
                }
            })
        }
    }
}
</script>